function handleNewsletterSubscription() {
    let newsForm = document.querySelectorAll('.newsletter-form')
    newsForm.forEach(form => {
        let submitBtn = form.querySelector('input[type="submit"]')
        let fakeBtn = form.querySelector('.newsletter__submit')
        fakeBtn.addEventListener('click', () => {
            submitBtn.click()
        })
    })
}

export default handleNewsletterSubscription